import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CRow,CCol,
	CForm,CFormInput,CFormSelect,CInputGroup,CInputGroupText,CFormCheck,
		CFormTextarea,CButton,
	CCard,CCardHeader,CCardBody,CCardFooter,
	CImage,
	CLink,
	CTooltip,
	CDropdown,CDropdownToggle,CDropdownMenu,CDropdownItem,CDropdownDivider,
	CSpinner,
	CBadge,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import NumberFormat from 'react-number-format';
import { isMobile } from "react-device-detect";
import {
	MyPagination,
	MyDialogform,
	MyDialoglookup,
} from '../components/index'
import { Konfirm } from '../helpers/onConfirm'
import { UFunc } from '../helpers/functions'

const pjson 		= require('../../package.json')
const Terapisetting = (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif
	} = props; 

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingObj 				= useSelector(state => state.gListUserSetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uConfigappsObj			= useSelector(state => state.uConfigappsObj) || {}; 
	const [uEfekview,setEfekview] 	= React.useState(false);
	const uMaxData					= isMobile ? (uSettingObj.jml_mobile || 15) : 100;//(uSettingObj.jml_tabel || 30);
	const uKeywordObj				= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uISDemoapp				= uConfigappsObj.level_app === "DEMO";
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uISEditallowed				= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN");
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const [uTimeelapse,setTimeelapse]	= React.useState(0); 
	
	const uHeaderActionObj  = useSelector(state => state.gInitHeaderAction);
	const uHandelView 		= uHeaderActionObj.isHeaderView || false;
	const uHandelTambah 	= uHeaderActionObj.isHeaderTambah || false;

	//--VIEWS_VARS--/
	const [uJmlData,setJmlData]			= React.useState(0);
	const [uPageActive,setPageActive]	= React.useState(1);
	const [uJmlHal,setJmlHal]			= React.useState(1);
	const [uDatamainArr,setDatamainArr]	= React.useState([]);
	const [uIdxRowselected,setIdxRowselected]= React.useState(-1);
	const [uIDselect,setIDselect]		= React.useState(0);
	const [uFirstload,setFirstload]		= React.useState(true);
	const [uTerapimainArr,setTerapimainArr]	= React.useState([]);
	const [uTerapimainID,setTerapimainID]	= React.useState(0);

	const uDatacabangArr	= JSON.parse(localStorage.getItem("cabanglist")||"[]")
	const uCabangIDinit		= (localStorage.getItem("lastcabangid")||"0")
	const uCabangIDselected	= (localStorage.getItem("cabangidselect")||uCabangIDinit)
	const uCabangselectObj	= uDatacabangArr.filter(vItems=> 
		(vItems.id).toString()===uCabangIDselected.toString());
	const uCabangIDArr		= uTokenObj.user_cabangarr ||[];
	const uCabangallowedArr	= uTokenObj.userhak!=="FREEROLE" ? uDatacabangArr.filter(vItems=>
		uCabangIDArr.includes((vItems.id||"").toString()) )
		: uDatacabangArr; 
	//--END VIEWS_VARS--/

	//---TABEL_VARS--/
	const [uInittabeleditObj,setInittabeleditObj]	= React.useState({});
	//---END TABEL_VARS--/

	//--DLG_LOOKUP--/
	const [uISDlglookupshow,setDlglookupshow]		= React.useState(false);
	const [uDlglookupObj,setDlglookupObj]			= React.useState({});
	//--END DLG_LOOKUP--/

	//---FORM_VARS--/
	const [uISDlgformshow,setDlgformshow]			= React.useState(false);
	const [uDlgformdataObj,setDlgformdataObj]		= React.useState({});
	//---END FORM_VARS--/

	//--DOM_VARS--/
	const uElJmlData	= document.getElementById("idjmldata");
	//--END DOM_VARS--/

	//--HANDEL--/
	const hdlKlikEdit = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0; if(_IDTABEL <= 0) return;

		setIDselect(_IDTABEL);
		const vArridx	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		const vIdxRow	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL)
		setIdxRowselected(vIdxRow);

		setDlgformdataObj({
			dlg_header:"Edit Terapi: "+(uDatamainArr[vArridx].terapi_caption||"").toUpperCase(),
			dlg_jenis:"TERAPISUB",
			tabel_id: parseInt(uDatamainArr[vArridx].id)||0,
			terapi_id: parseInt(uDatamainArr[vArridx].id_terapi)||0,
			nama_terapi: uDatamainArr[vArridx].nama_terapi||"",
			nama_terapi_sub: uDatamainArr[vArridx].nama_terapi_sub||"",
			icd9_code: uDatamainArr[vArridx].icd9_code||"",
			icd9_display: uDatamainArr[vArridx].icd9_display||"",
			biaya_bahan: parseFloat(uDatamainArr[vArridx].biaya_bahan)||0,
			biaya_jasa: parseFloat(uDatamainArr[vArridx].biaya_jasa)||0,
			cabangid_arr: [uCabangIDselected],
		});
		setDlgformshow(true);
	}
	const hdlKlikJenisterpilookup = () => {
		setDlglookupObj({
			dlg_header:"Lookup: JENIS TERAPI",
			data_arr: [...(uTerapimainArr.map((vItems=>{
				return {
					id: vItems.id,
					caption: vItems.nama_terapi||"",
				}
			})))]
		});

		setDlglookupshow(true);
	}
	const hdlKlikDlglookuppilih = (_IDITEM) => {
		_IDITEM	= parseInt(_IDITEM)||0; if(_IDITEM <= 0) return;

		const vArridx = UFunc.getObjectIndeks(uTerapimainArr,_IDITEM);
		setDlgformdataObj({...uDlgformdataObj,
			terapi_id: _IDITEM,
			nama_terapi: (uTerapimainArr[vArridx]||{}).nama_terapi||"",
		});
		setDlglookupshow(false);
	}
	const hdlKlikValueedit = (_IDTABEL,_FIELDEDIT) => {
		_IDTABEL 	= parseInt(_IDTABEL||0);
		_FIELDEDIT 	= (_FIELDEDIT||"").trim();

		const vArridx = UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		const vIdxRow	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL)
		setIdxRowselected(vIdxRow);

		let vValue;
		if(_FIELDEDIT === "biaya_bahan")
			vValue = parseFloat((uDatamainArr[vArridx]||{}).biaya_bahan)||0;
		else if(_FIELDEDIT === "biaya_jasa")
			vValue = parseFloat((uDatamainArr[vArridx]||{}).biaya_jasa)||0;

		setInittabeleditObj({
			tabel_id : _IDTABEL,
			fieldedit: _FIELDEDIT,
			value: vValue,
		})

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			const vElFocus = document.getElementById("inptabeledit");
			vElFocus && vElFocus.focus();
		},350);

		return;

		/*//--TIDAK_DIPAKAI--/
		initTabelawal();
		if(_IDTABEL <= 0) return;
		if(_FIELDEDIT === "") return;

		const vArridx = UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		uDatamainArr[vArridx].init_fieldedit = _FIELDEDIT;
		let vElFocus;
		if(_FIELDEDIT==="biaya_bahan") {
			vElFocus = ("inptabeledit"+_IDTABEL);
			setInpbiayabahanedit(uDatamainArr[vArridx].biaya_bahan||0);
		}else if(_FIELDEDIT==="biaya_jasa") {
			vElFocus = ("inptabeledit"+_IDTABEL);
			setInpbiayajasaedit(uDatamainArr[vArridx].biaya_jasa||0);
		}

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			const vElFocus = document.getElementById("inptabeledit");
			vElFocus && vElFocus.focus();
		},350);
		//--END TIDAK_DIPAKAI--*/
	}
	const hdlKDownValueedit = (_EV) => {
		if(_EV.which === 27) {
			_EV.preventDefault();
			setInittabeleditObj({});
			return;
		}
		if(_EV.which === 13) {
			_EV.preventDefault();
			_EV.stopPropagation();
			hdlKlikprosesedit();
			return;
		}
	}
	const hdlKlikprosesedit = () => {
		const vElFocus 	= document.getElementById("inptabeledit");
		const vArridx	= UFunc.getObjectIndeks(uDatamainArr,uInittabeleditObj.tabel_id);

		let vValueOld;
		let vValue;
		
		if(uInittabeleditObj.fieldedit === "biaya_bahan") {
			vValueOld 	= parseFloat(uDatamainArr[vArridx].biaya_bahan)||0;
			vValue 		= parseFloat(uInittabeleditObj.value)||0;
		} else if(uInittabeleditObj.fieldedit === "biaya_jasa") {
			vValueOld 	= parseFloat(uDatamainArr[vArridx].biaya_jasa)||0;
			vValue 		= parseFloat(uInittabeleditObj.value)||0;
		}

		if(vValueOld === vValue) {
			setInittabeleditObj({}); return;
		}

		if(uInittabeleditObj.fieldedit === "biaya_bahan") {
			if(vValue < 0) {
				vElFocus && vElFocus.focus();
				showToast("Biaya Bahan Tidak Valid !"); return;
			}
		} else if(uInittabeleditObj.fieldedit === "biaya_jasa") {
			if(vValue < 0) {
				vElFocus && vElFocus.focus();
				showToast("Biaya JASA Tidak Valid !"); return;
			}
		}

		apiProsesharga()
	}
	const hdlBlurTabeledit = () => {//--TIDAK_JADI_DIPAKAI--/
		return; //-->TIDAK_JADI--/
		if(!uInittabeleditObj.fieldedit) return;
		const vArridx = UFunc.getObjectIndeks(uDatamainArr,uInittabeleditObj.tabel_id);

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			if(((uDatamainArr[vArridx]||{}).init_process||false)===true) return;
			
			setInittabeleditObj({});
		},350);
	}
	const hdlKlikTerapijenistambah = () => {
		setIdxRowselected(-1);
		setDlgformdataObj({
			dlg_header: "Input Jenis Terapi Baru",
			dlg_jenis: "TERAPIJENIS",
		})
		setDlgformshow(true);
	}
	const hdlKlikHapus = async(_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0; if(_IDTABEL <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL)
		const vIdxRow	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL)
		setIdxRowselected(vIdxRow);

		const vCaptionupper = ((uDatamainArr[vArridx]||{}).terapi_caption||"Undf").toUpperCase();

		if(await Konfirm(
			"<p><b>Hapus Terapi: '"+vCaptionupper+"'</b>..</p>"+
			"<p>Apakah Yakin Akan Menghapus ?</p>"+
			"")) apiProseshapus(_IDTABEL);
	}
	const hdlKlikDlgformsimpan = () => {
		if(uDlgformdataObj.dlg_jenis==="TERAPISUB")
			{prosesDlgformterapisub(); return }
		if(uDlgformdataObj.dlg_jenis==="TERAPIJENIS")
			{prosesDlgformterapijenis(); return }
	}
	//--END HANDEL--/

	//--INIT--/
	const prosesDlgformterapisub = () => {
		let vElFocus = document.getElementById("inpformterapijenisnama");
		if((parseInt(uDlgformdataObj.terapi_id)||0) <= 0) {
			vElFocus && vElFocus.focus();
			showToast("Jenis Terapi Harus Dipilih Dahulu !"); return;
		}
		vElFocus = document.getElementById("inpformterapisubnama");
		if((uDlgformdataObj.nama_terapi_sub||"").trim() == "") {
			vElFocus && vElFocus.focus();
			showToast("Nama Sub Terapi Harus Diisi !"); return;
		}
		if((uDlgformdataObj.nama_terapi_sub||"").trim().length < 3) {
			vElFocus && vElFocus.focus();
			showToast("Nama Sub Terapi Minimal Harus 3 Karakter !"); return;
		}
		if((uDlgformdataObj.icd9_code||"").trim() != "" || (uDlgformdataObj.icd9_display||"").trim() != "") {
			vElFocus = document.getElementById("inpformicd9code");
			if((uDlgformdataObj.icd9_code||"").trim() == "") {
				vElFocus && vElFocus.focus();
				showToast("ICD9 Code dan ICD9 Display Harus Diisi Semuanya !"); return;
			}
			vElFocus = document.getElementById("inpformicd9display");
			if((uDlgformdataObj.icd9_display||"").trim() == "")  {
				vElFocus && vElFocus.focus();
				showToast("ICD9 Code dan ICD9 Display Harus Diisi Semuanya !"); return;
			}
		}
		vElFocus = document.getElementById("inpformbiayabahan");
		if((parseFloat(uDlgformdataObj.biaya_bahan)||0) < 0) {
			vElFocus && vElFocus.focus();
			showToast("Biaya Bahan Tidak Valid !"); return;
		}
		vElFocus = document.getElementById("inpformbiayajasa");
		if((parseFloat(uDlgformdataObj.biaya_jasa)||0) < 0) {
			vElFocus && vElFocus.focus();
			showToast("Biaya JASA Tidak Valid !"); return;
		}
		vElFocus = document.getElementById("inpformcabangall");
		if((uDlgformdataObj.cabangid_arr||[]).length <= 0){
			vElFocus && vElFocus.focus();
			showToast("Tarif Cabang Harus Dipilih Dahulu !"); return;
		}

		apiProsesmain();
	}
	const prosesDlgformterapijenis = () => {
		let vElFocus = document.getElementById("inpterapijenisnama");
		if((uDlgformdataObj.nama_terapi||"").trim() == "") {
			vElFocus && vElFocus.focus();
			showToast("Nama Jenis Terapi Harus Diisi !"); return;
		}
		if((uDlgformdataObj.nama_terapi||"").trim().length < 3) {
			vElFocus && vElFocus.focus();
			showToast("Nama Jenis Terapi Minimal Harus Diisi !"); return;
		}

		apiProsesjenisterapi();
	}
	//--END INIT--/

	//--CONTENT--/
	const contentTerapijenis = () => {
		if(uTerapimainArr.length <= 0) return ""

		return (
		<>
		{uTerapimainArr.map((vItems,vKeys)=>{
			const { nama_terapi,id } = vItems;

			const vTerapijenisArr = uDatamainArr.filter(vItemterapi=>
				(parseInt(vItemterapi.id_terapi)||0)===(parseInt(id)||0)
				);

			return (
				<option value={id} key={vKeys}>
					{(nama_terapi||"").toUpperCase()}
					{" "}&middot;{" "}
					({vTerapijenisArr.length})
				</option>
			)//>
		})}
		</>
		)//>
	}
	const contentMain = () => {
		if(uHtml500msg) return ""

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= (vMin);
		const vKeyword 		= UFunc.filterRegex(uKeywordObj.kwd_terapisetting || "");
		const vKeywordcolor = uSettingObj.color_keyword || "#D725FF";
		const vReplace 		= new RegExp(vKeyword,"ig");

		let vDataviewArr	= uDatamainArr; 
		if((parseInt(uTerapimainID)||0) > 0) {
			vDataviewArr	= vDataviewArr.filter(vItems =>
				parseInt(vItems.id_terapi||"0") === parseInt(uTerapimainID))
		}
		vDataviewArr	= vDataviewArr.slice(vMin,(vMax));

		//console.log("(Terapisetting - contentMain) vDataviewArr = "+JSON.stringify(vDataviewArr));

		const vColcaptionmd 	= uTokenObj.userhak==="ENTRI" ? 10 : 6;
		const vColcaptionlg 	= uTokenObj.userhak==="ENTRI" ? 10 : 6;

		return (
		<table className="table table-borderless table-striped table-hover" id="idtabeldata">
		<thead>
			<tr className="d-none d-md-table-row text-center align-top classfontsmaller">
			<th width={40} className="px-1"><small>No</small></th>
			<th className="px-0">
			<CRow className="mx-0">
			{(uTokenObj.userhak === "FREEROLE" || uTokenObj.userhak === "ADMIN"
				|| uTokenObj.userhak === "DOKTER"
			) ? (
			<>
				<CCol md="6" className="px-1 text-start"><small>{uBahasaObj.caption_namaterapi||"Nama Terapi"}</small></CCol>
				<CCol md="2" className="px-1"><small>Biaya Bahan (Rp)</small></CCol>
				<CCol md="2" className="px-1"><small>Biaya Jasa (Rp)</small></CCol>
			</>
			) : (
				<CCol md="10" className="px-1 text-start"><small>{uBahasaObj.caption_namaterapi||"Nama Terapi"}</small></CCol>
			)}
			<CCol md="2" className="px-1"><small>Total Tarif (Rp)</small></CCol>
			</CRow>
			</th>
			</tr>

			<tr className="d-md-none classfontsmaller p-0">
			<th width={35} className="p-0"/>
			<th className="p-0"/>
			</tr>
		</thead>

		<tbody>
		{vDataviewArr.map((vItems,vKeys) => {
			const {
				id,terapi_caption,biaya_bahan,biaya_jasa,nama_terapi,
				nama_terapi_sub,tgl_input,user_input,
				icd9_code,icd9_display,
				init_process,init_fieldedit
			} = vItems;

			vNumber++;
			const vCaptionupper	= (terapi_caption||"").toUpperCase();

			const vTerapijenis	= vKeyword==="" ? (nama_terapi||"") 
				: (nama_terapi||"").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</u></b>");
			const vTerapinamasub	= vKeyword==="" ? (nama_terapi_sub||"") 
				: (nama_terapi_sub||"").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</u></b>");
			const vICD9code	= vKeyword==="" ? (icd9_code||"") 
				: (icd9_code||"").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</u></b>");
			const vICD9name	= vKeyword==="" ? (icd9_display||"") 
				: (icd9_display||"").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</u></b>");
			
			return (
			<tr id={"idtr"+id} key={vKeys} className={"align-top text-end"+(uIdxRowselected===vKeys?" classrowselect":"")}>
				<td className="px-1">{vNumber}.</td>

				<td className="px-0">
				<CRow className="mx-0">
				<CCol md={vColcaptionmd} lg={vColcaptionlg} className="px-1 text-start">
					<div className="d-flex justify-content-between">
						<div className="pe-1">
						<b className="text-uppercase">{UFunc.renderHTML(vTerapijenis)}</b>
						<i className="text-capitalize text-info">{" "}{UFunc.renderHTML(vTerapinamasub)}</i>
						</div>
						
						{(uISEditallowed) && (
						<>
						<CDropdown className="d-md-none">
						<CDropdownToggle caret={false} size="sm"
							className="p-0" 
							color="transparent">
							<CIcon icon="cilOptions" height={18}/>
						</CDropdownToggle>
						<CDropdownMenu>
							<CDropdownItem onClick={()=>hdlKlikEdit(id)}>
								<CIcon className="classikonedit align-middle me-2" height={25}/>
								Edit Data Terapi
							</CDropdownItem>

							{(uTokenObj.userhak==="FREEROLE" && !uISDemoapp) && (
							<>
							<CDropdownDivider/>
							<CDropdownItem onClick={()=>hdlKlikHapus(id)}>
								<CIcon className="classikonhapus align-middle me-2" height={25}/>
								Hapus Terapi
							</CDropdownItem>
							</>
							)}
						</CDropdownMenu>
						</CDropdown>

						<div style={{minWidth:60}} className="d-none d-md-block text-center">
						<CLink onClick={()=>hdlKlikEdit(id)} className="classikontabel classikonedit classcursorpointer"/>
						
						{(uTokenObj.userhak==="FREEROLE" && !uISDemoapp) && (
						<CLink onClick={()=>hdlKlikHapus(id)} className="classikontabel classikonhapus classcursorpointer"/>
						)}
						</div>
						</>
						)}
					</div>

					{(icd9_code || "").trim() !== "" && (
					<div className="classfontsmaller"> 
					<small className="fst-italic">
						<span className="text-uppercase">{UFunc.renderHTML(vICD9code)}</span>
						<span> &middot; </span>
						<span className="text-capitalize">{UFunc.renderHTML(vICD9name)}</span>
					</small>
					</div>
					)}
				</CCol>

				{(uTokenObj.userhak === "FREEROLE" || uTokenObj.userhak === "ADMIN"
					|| uTokenObj.userhak === "DOKTER"
				) && (
				<>
				<CCol xs="12" className="px-1 my-3 d-md-none classborderbottom"/>

				<CCol xs="6" className="px-1 d-md-none text-start">Biaya Bahan</CCol>
				<CCol xs="6" className="px-1 d-md-none">
					{UFunc.formatAngka(biaya_bahan)}
				</CCol>
				<CCol xs="6" md="2" className="px-1 d-none d-md-block">
					{((uInittabeleditObj.fieldedit||"")==="biaya_bahan"
						&& (parseInt(uInittabeleditObj.tabel_id)||0)===parseInt(id)
					)  ? (
					<>
						{(init_process||false)===false ? (
						<CInputGroup onBlur={()=>hdlBlurTabeledit()}
							size="sm">
							<NumberFormat 
								value={uInittabeleditObj.value}
								displayType={'text'} 
								thousandSeparator={"."} 
								decimalSeparator={","}
								allowNegative={false}
								onValueChange={(values) => setInittabeleditObj({...uInittabeleditObj,value:values.value})}
								renderText={values => (
									<CFormInput size="sm"
										value={values}
										className="bg-white text-end"
										onFocus={(e)=>e.target.select()}
										onChange={(e)=>setInittabeleditObj({...uInittabeleditObj,value:e.target.value})}
										onKeyDown={(e)=>hdlKDownValueedit(e)}
									id="inptabeledit"/>
								)} 
								prefix={!isMobile?"Rp":""}/>
							<CButton size="sm" color="dark" className="px-1"
								onClick={()=>hdlKlikprosesedit()}
								id="btntabelok">
								<CIcon icon="cilCheckAlt"/>
							</CButton>
						</CInputGroup>
						) : (
							<div align="center">
							<CSpinner color="warning" size="sm"/>
							</div>
						)}
					</>
					) : (
					<>
					{(uISEditallowed) ? (
						<CTooltip className={isMobile && "d-none"} content="--Klik untuk EDIT..">
						<CLink onClick={()=>hdlKlikValueedit(id,"biaya_bahan")}
							className="classcursorpointer text-decoration-none text-primary">
						{UFunc.formatAngka(biaya_bahan)}
						</CLink>
						</CTooltip>
					) : (
						<>
						{UFunc.formatAngka(biaya_bahan)}
						</>
					)}
					</>
					)}
				</CCol>

				<CCol xs="6" className="px-1 d-md-none text-start">Biaya Jasa</CCol>
				<CCol xs="6" className="px-1 d-md-none">
					{UFunc.formatAngka(biaya_jasa)}
				</CCol>
				<CCol xs="6" md="2" className="px-1 d-none d-md-block">
					{((uInittabeleditObj.fieldedit||"")==="biaya_jasa"
						&& (parseInt(uInittabeleditObj.tabel_id)||0)===parseInt(id)
					)  ? (
					<>
						{(init_process||false)===false ? (
						<CInputGroup onBlur={()=>hdlBlurTabeledit()}
							size="sm">
							<NumberFormat 
								value={uInittabeleditObj.value}
								displayType={'text'} 
								thousandSeparator={"."} 
								decimalSeparator={","}
								allowNegative={false}
								onValueChange={(values) => setInittabeleditObj({...uInittabeleditObj,value:values.value})}
								renderText={values => (
									<CFormInput size="sm"
										value={values}
										className="bg-white text-end"
										onFocus={(e)=>e.target.select()}
										onChange={(e)=>setInittabeleditObj({...uInittabeleditObj,value:e.target.value})}
										onKeyDown={(e)=>hdlKDownValueedit(e)}
									id="inptabeledit"/>
								)} 
								prefix={!isMobile?"Rp":""}/>
							<CButton size="sm" color="dark" className="px-1"
								onClick={()=>hdlKlikprosesedit()}
								id="btntabelok">
								<CIcon icon="cilCheckAlt"/>
							</CButton>
						</CInputGroup>
						) : (
						<div align="center">
						<CSpinner color="warning" size="sm"/>
						</div>
						)}
					</>
					) : (
					<>
						{(uISEditallowed) ? (
							<CTooltip className={isMobile && "d-none"} content="--Klik Untuk Edit..">
							<CLink className="classcursorpointer text-decoration-none text-primary"
								onClick={()=>hdlKlikValueedit(id,"biaya_jasa")}>
								{UFunc.formatAngka(biaya_jasa)}
							</CLink>
							</CTooltip>
						) : (
							<>{UFunc.formatAngka(biaya_jasa)}</>
						)}
					</>	
					)}
				</CCol>
				</>
				)}

				<CCol xs="12" className="px-1 my-3 d-md-none classborderbottom"/>

				<CCol xs="6" className="px-1 d-md-none text-start">Total Tarif</CCol>
				<CCol xs="6" md="2" className="px-1 fw-bolder text-success">
					{UFunc.formatAngka(parseFloat(biaya_jasa) + parseFloat(biaya_bahan))}
				</CCol>

				</CRow>
				</td>
			</tr>
			)
		})}
		</tbody>
		</table>
		)//>
	}
	const contentDlgform = () => {
		if(!uISDlgformshow) return (<></>)//>

		if(uDlgformdataObj.dlg_jenis === "TERAPISUB") return contentFormTerapisub();
		if(uDlgformdataObj.dlg_jenis === "TERAPIJENIS") return contentFormTerapijenis();

		return (<></>)//>
	}
	const contentFormTerapisub = () => {
		if(uDlgformdataObj.dlg_jenis !== "TERAPISUB") return (<></>)//>

		return (
		<CForm className="mx-lg-5">
		<CRow className="my-2">
			<CCol xs="3" md="5" className="fw-bolder">
				<small className="d-md-none">Jns Terapi</small>
				<span className="d-none d-md-block">Jenis Terapi</span>
			</CCol>
			<CCol className="text-end">
				<CInputGroup size="sm">
					<CFormInput size="sm" readOnly={true}
						placeholder="--PILIH Jenis Terapi.."
						className="text-uppercase"
						value={uDlgformdataObj.nama_terapi||""}
						onClick={()=>hdlKlikJenisterpilookup()}
						id="inpformterapijenisnama"/>
					<CButton size="sm" color="dark"
						onClick={()=>hdlKlikJenisterpilookup()}
						id="btnformterapijenislookup">
						<CIcon icon="cilSearch"/>
					</CButton>
				</CInputGroup>
			</CCol>
		</CRow>

		<CRow className="my-2">
			<CCol xs="3" md="5" className="pe-1 fw-bolder">
				<small className="d-md-none">Sub Terapi</small>
				<span className="d-none d-md-block">Nama SUB Terapi</span>
			</CCol>
			<CCol className="text-end">
				<CFormInput size="sm" maxLength={100}
					className="text-capitalize"
					value={uDlgformdataObj.nama_terapi_sub||""}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,nama_terapi_sub:e.target.value})}
					id="inpformterapisubnama"/>
			</CCol>
		</CRow>

		<CRow className="my-2 mt-3">
			<CCol xs="3" md="5" className="">
				<small className="d-md-none">Label</small>
				<span className="d-none d-md-block">Label Nama Terapi</span>
			</CCol>
			<CCol className="">
				{((uDlgformdataObj.nama_terapi||"").trim()==="" 
					&& (uDlgformdataObj.nama_terapi_sub||"").trim()===""
				) ? (
					<i className="text-muted">&middot;UNDEFINED LABEL TERAPI&middot;</i>
				) : (
				<>
					<b className="text-uppercase">{uDlgformdataObj.nama_terapi||""}</b>
					<span> </span>
					<i className="text-info text-capitalize">{uDlgformdataObj.nama_terapi_sub||""}</i>
				</>
				)}
			</CCol>
		</CRow>

		{(1===3) && (
		<>
		<div className="my-3 classborderbottom"/>

		<CRow className="my-2">
			<CCol xs="3" md="5" className="pe-1">
				<small className="d-md-none">Kode ICD9CM</small>
				<span className="d-none d-md-block">Kode ICD9CM</span>
			</CCol>
			<CCol xs="auto" md="5" className="text-end">
				<CFormInput size="sm" maxLength={15}
					className="text-uppercase"
					value={uDlgformdataObj.icd9_code||""}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,icd9_code:e.target.value})}
					id="inpformicd9code"/>
			</CCol>
		</CRow>

		<CRow className="my-2">
			<CCol xs="3" md="5" className="pe-1">
				<small className="d-md-none">Nama ICD9CM</small>
				<span className="d-none d-md-block">Nama ICD9CM</span>
			</CCol>
			<CCol className="text-end">
				<CFormInput size="sm" maxLength={200}
					className="text-capitalize"
					value={uDlgformdataObj.icd9_display||""}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,icd9_display:e.target.value})}
					id="inpformicd9display"/>

				<div className="classpetunjuk px-2 text-start">
				<small>
					Untuk Referensi ICD9CM Satusehat, silahkan kunjungi:
					<a href="https://satusehat.kemkes.go.id/platform/docs/id/terminology/icd/icd-9-cm/" className="ms-1" target="_blank">
					LINK BERIKUT
					</a> 
				</small>
				</div>
			</CCol>
		</CRow>
		</>
		)}

		<div className="my-3 classborderbottom"/>

		<CRow className="my-2">
			<CCol xs="3" md="5" className="fw-bolder">
				<small className="d-md-none">B.Bahan</small>
				<span className="d-none d-md-block">Biaya Bahan</span>
			</CCol>
			<CCol xs="auto" md="5" className="text-end">
			<NumberFormat 
				value={uDlgformdataObj.biaya_bahan||0}
				displayType={'text'} 
				thousandSeparator={"."} 
				decimalSeparator={","}
				allowNegative={false}
				onValueChange={(values) => setDlgformdataObj({...uDlgformdataObj,biaya_bahan:values.value})}
				renderText={values => (
					<CFormInput size="sm"
						value={values}
						className="bg-white text-end"
						onFocus={(e)=>e.target.select()}
						onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,biaya_bahan:e.target.value})}
					id="inpformbiayabahan"/>
				)} 
			prefix={!isMobile && "Rp"}/>
			</CCol>
		</CRow>

		<CRow className="my-2">
			<CCol xs="3" md="5" className="fw-bolder">
				<small className="d-md-none">B.Jasa</small>
				<span className="d-none d-md-block">Biaya Jasa</span>
			</CCol>
			<CCol xs="auto" md="5" className="text-end">
				<NumberFormat 
					value={uDlgformdataObj.biaya_jasa||0}
					displayType={'text'} 
					thousandSeparator={"."} 
					decimalSeparator={","}
					allowNegative={false}
					onValueChange={(values)=>setDlgformdataObj({...uDlgformdataObj,biaya_jasa:values.value})}
					renderText={values => (
						<CFormInput size="sm"
							value={values}
							className="bg-white text-end"
							onFocus={(e)=>e.target.select()}
							onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,biaya_jasa:e.target.value})}
							onKeyDown={(e)=>{
								if(uDatacabangArr.length > 1) return;
								UFunc.hdlKeyDownInput(e,"btnDialogSimpan")
							}}
						id="inpformbiayajasa"/>
					)} 
				prefix={!isMobile && "Rp"}/>
			</CCol>
		</CRow>

		<CRow className="my-2 mt-3">
			<CCol xs="3" md="5" className="">
				<small className="d-md-none">Total</small>
				<span className="d-none d-md-block">Total Tarif</span>
			</CCol>
			<CCol xs="auto" md="5" className="text-end text-success">
				Rp{UFunc.formatAngka(
					(parseFloat(uDlgformdataObj.biaya_bahan)||0) 
					+ (parseFloat(uDlgformdataObj.biaya_jasa)||0)
					)}
			</CCol>
		</CRow>

		{uDatacabangArr.length > 1 && (
		<>
		<div className="my-3 classborderbottom"/>

		<CRow className="my-2">
			<CCol xs="3" md="5" className="d-flex justify-content-between align-items-start">
				<small className="d-md-none">Cabang</small>
				<span className="d-none d-md-block">Tarif Cabang</span>

				<CBadge color="secondary" className="p-2 mb-2 d-none d-md-inline-block">
					<input type="checkbox" className="align-middle"
						checked={(uDlgformdataObj.cabangid_arr||[]).length === uCabangallowedArr.length}
						onChange={(e)=>{
							if(e.target.checked) 
								setDlgformdataObj({...uDlgformdataObj,
									cabangid_arr: uCabangallowedArr.map(vItems=>vItems.id)
								})
							else 
								setDlgformdataObj({...uDlgformdataObj,cabangid_arr:[]})
						}}
						value="ALL"
						id="inpformcabangall"/>
				</CBadge>
			</CCol>

			<CCol className="">
			{uCabangallowedArr.map((vItems,vKeys)=>{
				const vTmpArr	= (uDlgformdataObj.cabangid_arr||[]).
					filter(vItemselect => parseInt(vItemselect) === parseInt(vItems.id));

				return (
				<React.Fragment key={vKeys}>
				<CBadge color="light" className="p-2 px-lg-3 mb-2 text-dark border border-dark">
					<input type="checkbox" className="align-middle"
						checked={vTmpArr.length > 0}
						onChange={(e)=>{
							if(e.target.checked) 
								setDlgformdataObj({...uDlgformdataObj,
									cabangid_arr: [...(uDlgformdataObj.cabangid_arr||[]),e.target.value]
								});
							else {
								const vDelidx = (uDlgformdataObj.cabangid_arr||[]).indexOf(e.target.value);
								(uDlgformdataObj.cabangid_arr||[]).splice(vDelidx,1);
								setEfekview(!uEfekview);
							}
						}}
						onKeyDown={(e)=>{
							if(vKeys < uCabangallowedArr.length-1) return;

							UFunc.hdlKeyDownInput(e,"btnDialogSimpan")
						}}
						value={vItems.id}
						id={"inpcabang"+vItems.id}/>
					<label className="classcursorpointer d-inline-block ms-1" for={"inpcabang"+vItems.id}>
						{(vItems.cabang_nama||"Undf Cabang").toUpperCase()}
					</label>
				</CBadge>

				{(vKeys < uCabangallowedArr.length-1) && (
					<span className="me-1"/>
				)}
				</React.Fragment>
				)//>
			})}
			</CCol>
		</CRow>
		</>
		)}
		</CForm>
		)//>
	}
	const contentFormTerapijenis = () => {
		if(uDlgformdataObj.dlg_jenis !== "TERAPIJENIS") return (<></>)//>

		return (
		<CForm className="mx-lg-5 px-lg-5">
		<CRow className="my-2">
			<CCol md="5">Nama Jenis Terapi</CCol>
			<CCol>
			<CFormInput size="sm"
				value={uDlgformdataObj.nama_terapi||""}
				onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,nama_terapi:e.target.value})}
				onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
				id="inpformterapijenisnama"/>
			</CCol>
		</CRow>
		</CForm>
		)//>
	}
	//--END CONTENT--/

	//--API--/
	const apiLoaddata = () => {
		setHtml500msg();

		setJmlData(0);
		setDatamainArr([]);
		setIDselect(0);
		setIdxRowselected(-1);
		setPageActive(1);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		console.log("(Terapisetting - apiLoaddata) uFirstload = "+uFirstload)
		let vTimeout = setTimeout(()=>{
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vKeyword 			= uKeywordObj.kwd_terapisetting || "";
		const vCabangIDselect 	= uCabangIDselected;
		const vDATAS	= JSON.stringify({
			send_firstload : uFirstload===true ? "YA" : "TIDAK",
			send_keyword : vKeyword,
			send_cabangid: vCabangIDselect,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_terapisetting/ld_data";

		setTimeelapse(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false);return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.tampil) {
				const vTmpObj = JSON.parse(output_string.dataobject||"[]");
				setDatamainArr(vTmpObj);
				setJmlData((parseInt(vTmpObj.length)||0));

				//console.log("(Terapisetting - apiLoaddata) send_firstload = "+output_string.send_firstload)

				setTerapimainArr(JSON.parse(output_string.dataterapi || JSON.stringify(uTerapimainArr)));
				if(uFirstload) setFirstload(false);

				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeelapse(vTimeDiff);
			} else if(output_string.info) {
				setHtml500msg(output_string.info);
			} else if(output_string.errors) {
				console.log("(Terapisetting - apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Terapisetting - apiLoaddata) catch-error : "+error);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiProsesharga = () => {
		const vArridx	= UFunc.getObjectIndeks(uDatamainArr,uInittabeleditObj.tabel_id);
		const vValuenew	= uInittabeleditObj.value;
		uDatamainArr[vArridx]	= {...(uDatamainArr[vArridx]||{}),
			init_process: true,
		}
		setEfekview(!uEfekview);

		/*//--TESTING_FRONTEND--/
		console.log("(Terapisetting - apiProsesharga) LEWaT "); 
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_cabangid : uCabangIDselected,
			send_parameter: JSON.stringify({...uInittabeleditObj}),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_terapisetting/pr_simpanharga";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false);return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			if(output_string.sukses) {
				uDatamainArr[vArridx]	= {...(uDatamainArr[vArridx]||{}),
					biaya_bahan: uInittabeleditObj.fieldedit==="biaya_bahan"?vValuenew:(uDatamainArr[vArridx]||{}).biaya_bahan,
					biaya_jasa: uInittabeleditObj.fieldedit==="biaya_jasa"?vValuenew:(uDatamainArr[vArridx]||{}).biaya_jasa,
					init_process: false,
				}

				setInittabeleditObj({})
			} else {
				uDatamainArr[vArridx]	= {...(uDatamainArr[vArridx]||{}),
					init_process: false,
				}
				document.getElementById("inptabeledit") &&
					document.getElementById("inptabeledit").focus()
				if(output_string.info) {
					showToast(output_string.info);
				} else if(output_string.errors) {
					console.log("(Terapisetting - apiProsesharga) output_string.errors : "+output_string.errors);
					const vMsg = (pjson.mydefault.environment==="development")
						? output_string.errors : pjson.mydefault.msgFetchError;
					showToast(vMsg,"ERROR");
				} else if(output_string.expired) {
					setLoading(true); prosesExpired();
				}
			}
		})
		.catch((error) =>{
			uDatamainArr[vArridx]	= {...(uDatamainArr[vArridx]||{}),
				init_process: false,
			}
			console.log("(Terapisetting - apiProsesharga) catch-error : "+error);
			document.getElementById("inptabeledit") &&
				document.getElementById("inptabeledit").focus()
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiProsesmain = () => {
		const vArridx	= UFunc.getObjectIndeks(uDatamainArr,uDlgformdataObj.tabel_id);
		const vElsbutton= document.getElementById("btnDialogSimpan");

		vElsbutton && (vElsbutton.disabled = true);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		console.log("(Terapisetting - apiProsesmain) LEWaT "); 
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_cabangid : uCabangIDselected,
			send_parameter: JSON.stringify({...uDlgformdataObj,
				dlg_header:undefined,
				dlg_jenis:undefined,
			}),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_terapisetting/pr_simpanmain";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false);return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			vElsbutton && (vElsbutton.disabled = false);
			if(output_string.sukses) {
				const vTmpObj = {
					id_terapi: (parseInt(uDlgformdataObj.terapi_id)||0),
					nama_terapi: (uDlgformdataObj.nama_terapi||"Undf Terapi").trim(),
					nama_terapi_sub: (uDlgformdataObj.nama_terapi_sub||"Undf Sub").trim(),
					icd9_code: (uDlgformdataObj.icd9_code||"").trim(),
					icd9_display: (uDlgformdataObj.icd9_display||"").trim(),
					biaya_bahan: (parseFloat(uDlgformdataObj.biaya_bahan)||0),
					biaya_jasa: (parseFloat(uDlgformdataObj.biaya_jasa)||0),
					terapi_caption: (uDlgformdataObj.nama_terapi||"Undf Terapi").trim().toUpperCase()+
						' '+(uDlgformdataObj.nama_terapi_sub||"Undf Sub").trim(),
				}

				if(vArridx < 0) {
					setDatamainArr([{
						id:parseInt(output_string.tabelidnew||"255"),
						...vTmpObj,
					},...uDatamainArr]);

					showToast((uBahasaObj.pesan_sukses||"BERHASIL !")+
						"","SUKSES");

					setDlgformdataObj({...uDlgformdataObj,
						terapi_id: uTerapimainID,
						nama_terapi: "",
						nama_terapi_sub: "",
						icd9_code: "",
						icd9_display: "",
						biaya_bahan: 0,
						biaya_jasa: 0,
						cabangid_arr: uCabangallowedArr.map(vItems=>vItems.id),
					});

					if(!isMobile)
						document.getElementById("inpformterapisubnama") &&
							document.getElementById("inpformterapisubnama").focus();
				} else {
					uDatamainArr[vArridx] = {
						...(uDatamainArr[vArridx]||{}),
						...vTmpObj,
					}
					setDlgformshow(false);
				}
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Terapisetting - apiProsesmain) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			vElsbutton && (vElsbutton.disabled = false);
			setLoading(false);
			console.log("(Terapisetting - apiProsesmain) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiProsesjenisterapi = () => {
		const vElsbutton= document.getElementById("btnDialogSimpan");
		vElsbutton && (vElsbutton.disabled = true);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		console.log("(Terapisetting - apiProsesjenisterapi) LEWaT "); 
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_parameter: JSON.stringify({...uDlgformdataObj,
				dlg_header:undefined,
				dlg_jenis:undefined,
			}),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_terapijenis/pr_simpan";
		//const vURLs	= pjson.homepage+"api/api_terapisetting/pr_simpanjenisterapi";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false);return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			vElsbutton && (vElsbutton.disabled = false);
			setLoading(false);
			if(output_string.sukses) {
				//const vNewtabelid = parseInt(output_string.tabelidnew||"255");
				const vNewtabelid = parseInt(output_string.tabelnewid||"255");
				setTerapimainArr([{
					id: vNewtabelid,
					nama_terapi: uDlgformdataObj.nama_terapi||"Undf Terapi",
				},...uTerapimainArr]);

				setDlgformshow(false);
				setTerapimainID(vNewtabelid);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Terapisetting - apiProsesjenisterapi) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			vElsbutton && (vElsbutton.disabled = false);
			setLoading(false);
			console.log("(Terapisetting - apiProsesjenisterapi) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiProseshapus = (_IDTABEL) => {
		_IDTABEL	= parseInt(_IDTABEL)||0;
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		console.log("(Terapisetting - apiProseshapus) LEWaT "); 
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tabelid: _IDTABEL,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_terapisetting/pr_hapus";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false);return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.sukses) {
				const vArridx = UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
				uDatamainArr.splice(vArridx,1);
				setEfekview(!uEfekview);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Terapisetting - apiProseshapus) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Terapisetting - apiProseshapus) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//--END API--/

	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});

    	apiLoaddata();

    	return () => {
			uDispatch({type: "set", gInitHeaderAction: {}});
			setDlgformshow(false);

    		setDatamainArr([]); setInittabeleditObj({});
			setTerapimainArr([]); setFirstload(true);
    		localStorage.removeItem("cabangidselect")
    	}
	},[])
	React.useEffect(()=>{
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);//-*/
		setPageActive(uPageActive<=0?1:uPageActive);

		/*const vKeyword = uKeywordObj.kwd_terapisetting || "";
		if(vKeyword.length <= 2) {
			uElJmlData && (uElJmlData.innerHTML = "&#8734;");
			return;
		}//-*/
		uElJmlData && (uElJmlData.innerHTML = UFunc.formatAngka(uJmlData));

		const vEljmldatamobile = document.getElementById("idjmldatamobile");
		vEljmldatamobile && (vEljmldatamobile.innerHTML = UFunc.formatAngka(uJmlData));
	},[uJmlData])
	React.useEffect(()=>{
		setIdxRowselected(-1);
		setPageActive(1);

		let vJmldata;
		if(parseInt(uTerapimainID) > 0) {
			vJmldata = (uDatamainArr.filter(vItems => 
				parseInt(vItems.id_terapi||"0") === parseInt(uTerapimainID))||[]).length;
		} else {
			vJmldata = uJmlData;
		}
		const vJmlHal	= Math.ceil(vJmldata / uMaxData);
		setJmlHal(vJmlHal);//-*/
	},[uTerapimainID])
	React.useEffect(()=>{ setIdxRowselected(-1); },[uPageActive])//-->Unselect_ROW
	React.useEffect(()=>{
		if(!uHandelView) return;

		uHeaderActionObj.isHeaderView = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		apiLoaddata();
	},[uHandelView])
	React.useEffect(()=>{
		if(!uHandelTambah) return;

		uHeaderActionObj.isHeaderTambah = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		setIdxRowselected(-1);
		if(uHtml500msg) return;

		setDlgformdataObj({
			dlg_header: "Tambah Terapi Baru",
			dlg_jenis: "TERAPISUB",
			terapi_id: uTerapimainID||0,
			cabangid_arr: uCabangallowedArr.map(vItems=>vItems.id),
		});

		setDlgformshow(true);
	},[uHandelTambah])
	/*React.useEffect(()=>{
		//console.log("("+cComponentName+"[uIsScrollBottom]) uIsScrollBottom: "+uIsScrollBottom);
		if(!isMobile) return;
		if(!uIsScrollBottom) return;
		
		const vPageNow	= uPageActive;
		if(vPageNow+1 > uJmlHal) return;
		setPageActive(vPageNow+1);
	},[uIsScrollBottom])//-*/
	React.useEffect(()=>{
		if(!uISDlgformshow) 
			{ setDlgformdataObj({}); return; }

		let vTimeout = setTimeout(function(e){
			clearTimeout(vTimeout);

			let vElFocus = document.getElementById("inpformterapijenisnama");
			/*if(uDlgformdataObj.dlg_jenis === "TERAPIJENIS")
				vElFocus = document.getElementById("inpformterapijenisnama");//-*/

			if(!isMobile)
				vElFocus && vElFocus.focus();
		},200);
	},[uISDlgformshow])
	/*React.useEffect(()=>{//--TIDAK_DIPAKAI--/
		if(!uISDlgformshow) return;
		if(uDlgformdataObj.dlg_jenis!=="TERAPISUB") return;

		const vArridx = UFunc.getObjectIndeks(uTerapimainArr,uDlgformdataObj.terapi_id);
		if(vArridx < 0) {
			setDlgformdataObj({...uDlgformdataObj,nama_terapi:""})
			return;
		}

		setDlgformdataObj({...uDlgformdataObj,
			nama_terapi:uTerapimainArr[vArridx].nama_terapi||"Undf Terapi"
		});
	},[uDlgformdataObj.terapi_id])//-*/

	//console.log("Terapisetting - uPageActive => "+JSON.stringify(uPageActive));

	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }
	if(uHtml500msg)  return (
		<CCard className="classbgcard">
		<CCardHeader>
		<b>{uBahasaObj.caption_page500||"Page 500"}</b>
		</CCardHeader>
		<CCardBody>{UFunc.renderHTML(uHtml500msg)}</CCardBody>
		</CCard>
	)

	return (
		<>
		<CCard className="classbgcard">
		<CCardHeader className="d-flex justify-content-between align-items-center px-1 px-md-3">
		<div>
			<CInputGroup size="sm" className="align-items-center">
			{uDatacabangArr.length > 1 && (
			<>
				{uCabangselectObj.length > 0 && (
				<>
					<b className="d-none d-md-inline">{uCabangselectObj[0].cabang_nama}</b>
				</>
				)}
				<span className="mx-1 d-none d-md-inline">&middot;</span>
			</>
			)}
			<CFormSelect size="sm"
				style={{maxWidth:350}}
				onChange={(e)=>setTerapimainID(e.target.value)}
				value={uTerapimainID}
				id="inpterapimain">
				<option value="0">-- SEMUA JENIS TERAPI --</option>
				{contentTerapijenis()}
			</CFormSelect>

			{((uTokenObj.userhak === "FREEROLE" || uTokenObj.userhak==="ADMIN") && !uISDemoapp) && (
			<>
			<span className="mx-1 d-none d-lg-inline-block">&middot;</span>

			<CTooltip className={isMobile?"d-none":""} content="--Tambah Jenis Terapi">
			<CLink onClick={()=>hdlKlikTerapijenistambah()} className="d-none d-md-block classcursorpointer">
				<CIcon icon="cibAddthis" className="classikonbox" height={25}/>
			</CLink>
			</CTooltip>
			</>
			)}
			</CInputGroup>
		</div>

		<span className="text-muted classfontsmaller ps-1">
			<small>{UFunc.formatAngka(uTimeelapse)}ms</small>
		</span>
		</CCardHeader>
		
		<CCardBody className="px-0">{contentMain()}</CCardBody>

		{(()=>{
			let vJmldata;
			if(parseInt(uTerapimainID) > 0) {
				vJmldata = (uDatamainArr.filter(vItems => 
					parseInt(vItems.id_terapi||"0") === parseInt(uTerapimainID))||[]).length;
			} else {
				vJmldata = uJmlData;
			}
			
			if(vJmldata > uMaxData)
			return (
			<CCardFooter>
				<MyPagination 
					activePage={uPageActive}
					pages={uJmlHal}
					onActivePageChange={(i)=>setPageActive(i)}
					align="start"/>
			</CCardFooter>
			)	
		})()}
		</CCard>

		<MyDialoglookup
			show={uISDlglookupshow}
			toggle={()=>setDlglookupshow(false)}
			dialogHeader={uDlglookupObj.dlg_header||"Lookup Data"}
			inputValue={uDlglookupObj.inputvalue||""}
			dataItemArr={uDlglookupObj.data_arr || []} 
			onKlikPilihItem={hdlKlikDlglookuppilih}
			id="iddialoglookup"
			{...props}/>

		<MyDialogform
			options={{size:"lg",centered:true}}
			onSimpan={()=>hdlKlikDlgformsimpan()}
			show={uISDlgformshow} 
			dialogHeader={uDlgformdataObj.dlg_header}
			toggle={()=>setDlgformshow(false)}
			renderContent={contentDlgform()}/>
		</>
	)//>
}	

export default Terapisetting